import type { NavbarMenuListGroupElementProps } from '@/navbarElement/Navbar.type';
import type { CSSProperties } from 'react';
import { cn } from '../../utils/cn';
import * as styles from '../Navbar.css';

export function NavbarMenuListGroupV2({
  element,
  className,
  children,
  style,
  attributes,
}: NavbarMenuListGroupElementProps) {
  const { type, justify, customAttributes, lineDividerStyle, lineDividerWidth, lineDividerColor } = element.attrs || {};

  const showDivider = lineDividerStyle && lineDividerStyle !== 'none';

  const dividerStyle = showDivider
    ? ({
        '--divider-width': lineDividerWidth || '1px',
        '--divider-style': lineDividerStyle || 'solid',
        '--divider-color': lineDividerColor || '#000000',
        '--divider-gap': '8px',
      } as CSSProperties)
    : {};

  const baseStyle: CSSProperties = {
    '--min-height': 'var(--height)',
    ...dividerStyle,
    ...style,
  };

  const classes = cn(
    type === 'middle' && 'flex-1',
    type === 'left' && 'shrink-0',
    type === 'right' && 'shrink-0',
    styles.navbarMenuListGroupV2,
    type === 'left' && styles.alignLeftV2,
    type === 'middle' && justify === 'center' && styles.alignCenterV2,
    type === 'middle' && justify === 'start' && styles.alignLeftV2,
    type === 'middle' && justify === 'end' && styles.alignRightV2,
    type === 'right' && styles.alignRightV2,
    showDivider && 'navbar-divider-group',
    className,
  );

  // Handle flex justification for middle type groups
  const flexJustify = type === 'middle' && justify ? `justify-${justify}` : '';

  return (
    <div {...attributes} {...customAttributes} style={baseStyle} className={cn(classes, flexJustify)}>
      {children}
    </div>
  );
}
